import { createRecordFromEntries } from "../utils/enum/createRecordFromEntries.js";
import { SubscriptionSize } from "./SubscriptionSize.js";
import { subscriptionSizeToWeightMap } from "./utils/subscriptionSizeToWeightMap.js";

const fathersChoicePriceByWeight: Record<(typeof subscriptionSizeToWeightMap)[SubscriptionSize], number> = {
	250: 359,
	1000: 1238,
};

export const fathersChoicePriceCzkBySize = createRecordFromEntries(
	SubscriptionSize,
	Object.values(SubscriptionSize).map((size) => [size, fathersChoicePriceByWeight[subscriptionSizeToWeightMap[size]]]),
);
